import SharedTicketDetailCard from "../default/components/TicketDetailCard";

const TicketDetailCard = (props) => {
    return <SharedTicketDetailCard variant="it-support" {...props} />;
};

export default TicketDetailCard;